import { convertObjectToArray } from 'util/convertObjectToArray';

import { TrendItemsApi } from 'api/TrendItemsApi';
import { DepartmentModel, mapDepartmentDtoToModel } from 'api/dto/Department.dto';

export type TrendQuestion = {
  questionId: number;
  questionContent: string;
  categoryName: string;
  projectName: string;
};

export class TrendItemsRepository {
  constructor(private trendItemsApi: TrendItemsApi) {}

  list(id: number): Promise<TrendQuestion[]> {
    return this.trendItemsApi.list(id).then((result) => convertObjectToArray(result));
  }

  setConnectedDepartments(
    sourceId: number,
    destinationId: number | null,
  ): Promise<DepartmentModel> {
    return this.trendItemsApi
      .setConnectedDepartments(sourceId, destinationId)
      .then((result) => mapDepartmentDtoToModel(result));
  }
}
